import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import BaseLang from './BaseLang';
import reportWebVitals from './reportWebVitals';
import numeral from 'numeral';

numeral.register('locale', 'pt', {
  delimiters: {
      thousands: ' ',
      decimal: ','
  },
  abbreviations: {
      thousand: 'm',
      million: 'M',
      billion: 'B',
      trillion: 'T'
  },
  ordinal : function (number) {
      return number === 1 ? '' : '';
  },
  currency: {
      symbol: '€'
  }
});

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={""}>
      <Router>
        <BaseLang />
      </Router>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
